"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _VidyardActions = require("crm_ui/extensions/vidyard/VidyardActions");

var _ActionNamespaces = require("crm_data/actions/ActionNamespaces");

var _LazyValueStore = require("crm_data/store/LazyValueStore");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var VidyardStore = (0, _LazyValueStore.defineLazyValueStore)({
  namespace: _ActionNamespaces.VIDYARD,
  fetch: _VidyardActions.getShouldSeeVidyardShepherd
}).defineName('VidyardStore').register(_dispatcher.default);
var _default = VidyardStore;
exports.default = _default;
module.exports = exports.default;